module.exports = "../images/arrow-lb-right-hover.png";